<template>
  <transition name="popover-fade" mode="out-in">
    <div v-if="show && !disable" class="cpt-popover-wrapper" ref="popover-content" @mousedown="handleMouseDown" :style="posStyle">
      <slot></slot>
      <div v-if="arrowPlacement" :x-placement="arrowPlacement" class="popover-arrow"></div>
    </div>
  </transition>
</template>

<script>
import { PopupManager } from 'element-ui/lib/utils/popup'
import { mapMutations } from 'vuex';
export default {
  props: {
    triggerRef: {
      default: null
    },
    triggerType: {
      type: String,
      default: 'hover'
    },
    hideDelay: {
      type: Number,
      default: 360
    },
    showDelay: {
      type: Number,
      default: 0
    },
    disable: {
      type: Boolean,
      default: false,
    },
    disabledHidden: {
      type: Boolean,
      default: false,
    },
    noHiddenClass: {
      type: String,
      default: ''
    },
    clickHidden: { // 在popover已经展示时，再次点击是否隐藏
      type: Boolean,
      default: false,
    },
    arrowPlacement: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    autoPos: {
      type: String,
      default: ''
    },
    offset: {
      type: Object,
      default: () => {
        return {
          x: 0,
          y: 0
        }
      }
    }
  },
  data () {
    return {
      init: false,
      show: false,
      lockContentShow: false,
      animationTime: 0,
      hoverLock: false,
      top: '',
      left: '',
      bottom: '',
      right: '',
      zIndex: 101,
      showPopoverHandle: null,
      hidePopoverHandle: null,
    }
  },
  mounted () {
    if (this.triggerRef) {
      this.initEvent()
    }
    window.addEventListener("mouseup", this.handleMouseUp)
  },
  beforeDestroy() {
    this.unbindEvent()
    window.removeEventListener("mouseup", this.handleMouseUp)
    if (this.appendToBody && this.contentRef && this.contentRef.parentNode) {
      this.contentRef.parentNode.removeChild(this.contentRef);
    }
  },
  watch: {
    triggerRef (n, o) {
      // 先解绑旧 ref，再绑定新 ref，避免同一元素被重复绑定或旧 ref 未解绑
      if (o) {
        this.unbindEvent(o)
      }
      if (n) {
        this.initEvent()
      }
    },
    hoverLock(v) {
      if (!v && this.waitHide) {
        this.hidePopover()
      }
    }
  },
  computed: {
    posStyle() {
      return {
        top: this.top,
        left: this.left,
        right: this.right,
        bottom: this.bottom,
        zIndex: this.zIndex
      }
    }
  },
  methods: {
    initEvent () {
      if (!this.triggerRef) {
        return
      }
      // 避免同一 triggerRef 被重复绑定（如 watch 与 mounted 竞态或父组件多次赋值同一 ref）
      if (this._initedTriggerRef === this.triggerRef) {
        return
      }
      this._initedTriggerRef = this.triggerRef
      if (this.triggerType === 'click') {
        this.triggerRef.addEventListener('click', this.clickShowEvent)
        if (!window.heyboxPopoverClickEventHandler) {
          window.heyboxPopoverClickEventHandler = []
          document.documentElement.addEventListener('click', this._click_evt_func, true)
        }
      } else {
        this.noHiddenAllEls = this.noHiddenClass && document.querySelectorAll('.' + this.noHiddenClass)
        this._hoverEnterEvent = this.showPopover.bind(this, 'trigger')
        this.noHiddenAllEls && this.noHiddenAllEls.forEach(item => {
          item.addEventListener('mouseenter', this._hoverEnterEvent)
        })
        this._hoverLeaveEvent = this.hidePopover.bind(this)
        this._hoverOverEvent = this.overPopover.bind(this)
        this.triggerRef.addEventListener('mouseenter', this._hoverEnterEvent)
        this.triggerRef.addEventListener('mouseleave', this._hoverLeaveEvent)
        // 防止triggerRef的按钮和popover的最外层dom距离很近时
        // 快速把鼠标从popover滑动到按钮，会只触发mouseleave不触发mouseenter
        // 增加mousemove事件托底
        this.triggerRef.addEventListener('mousemove', this._hoverOverEvent)
      }
    },
    clickShowEvent() {
      if (this.clickHidden) {
        if (!this.lockContentShow) {
          this.showPopover()
        }
      } else {
        this.showPopover()
      }
    },
    showPopover (path, force) {
      let func = () => {
        // 防止triggerType = hover时，在hide transition动画时间内重新hover后会再次触发展示
        if ((path == 'content' || this.triggerType == 'click') && (this.triggerType == 'hover' && this.lockContentShow)) return
        if(this.triggerRef) {
          this.zIndex = PopupManager.nextZIndex()
          const rect = this.triggerRef.getBoundingClientRect()
          let offset = Object.assign({x: 0, y: 0}, this.offset)
          this.autoPos.split(' ').forEach(pos => {
            switch(pos) {
              case 'left':
                this.left = rect.left + offset.x + 'px'
                break;
              case 'right':
                this.right = window.innerWidth - offset.x - rect.right + 'px'
                break;
              case 'top':
                this.top = rect.top + offset.y + 'px'
                break;
              case 'bottom':
                this.bottom = window.innerHeight - offset.y - rect.bottom + 'px'
                break;
              default:
                break;
            }
          })
        }
        clearTimeout(this.timer)
        this.timer = null
        this.show = true
        this.$emit('updateShow', true, this.$children)
        this.SET_POPOVER_SHOW(true)
        this.$nextTick(() => {
          this.contentRef = this.$refs['popover-content']
          if(!this.contentRef) return
          if(this.appendToBody) document.body.appendChild(this.contentRef)
          
          if (this.triggerType === 'hover') {
            if(this.showPopoverHandle || this.hidePopoverHandle) return
            this.showPopoverHandle = this.showPopover.bind(this, 'content'),
            this.hidePopoverHandle = this.hidePopover.bind(this)
            this.contentRef.addEventListener('mouseenter', this.showPopoverHandle)
            this.contentRef.addEventListener('mouseleave', this.hidePopoverHandle)
          }
        })
        if (this.triggerType === 'click') {
          if (!window.heyboxPopoverClickEventHandler) {
            window.heyboxPopoverClickEventHandler = []
          }
          window.heyboxPopoverClickEventHandler.push(this)
        }
      }

      if (!this.showDelay|| force === true) {
        func()
      } else {
        clearTimeout(this._showPopoverTimer)
        clearTimeout(this.timer)
        this.timer = null
        this._showPopoverTimer = setTimeout(() => {
          func()
        }, this.showDelay)
      }
    },
    overPopover (e) {
      // 如果popover处于展示状态，并且没有关闭的timer，不需要重复调用showPopover
      if (this.show && !this.timer) return
      this.showPopover()
    },
    hidePopover (e) {
      if (!this.hoverLock) {
        clearTimeout(this._showPopoverTimer)
        clearTimeout(this.timer)
        this.timer = null
        this.timer = setTimeout(() => {
          if(!this.contentRef) return
          this.showPopoverHandle && this.contentRef.removeEventListener('mouseenter', this.showPopoverHandle)
          this.hidePopoverHandle && this.contentRef.removeEventListener('mouseleave', this.hidePopoverHandle)
          this.showPopoverHandle = null
          this.hidePopoverHandle = null
          this.hidden()
        }, this.hideDelay)
        this.waitHide = false
      } else {
        this.waitHide = true
      }
    },
    hidden () {
      this.show = false
      this.$emit('updateShow', false)
      this.lockContentShow = true
      this.SET_POPOVER_SHOW(false)
      setTimeout(() => {
        this.lockContentShow = false
      }, this.animationTime)
      if (this.triggerType === 'click') {
        this.deleteShownInstance()
      }
    },
    deleteShownInstance () {
      let index = -1
      for (let i=0; i<window.heyboxPopoverClickEventHandler?.length; i++) {
        if (window.heyboxPopoverClickEventHandler[i] === this) {
          index = i
          break
        }
      }
      if (index >= 0) {
        window.heyboxPopoverClickEventHandler.splice(index, 1)
      }
    },
    unbindEvent (ref) {
      ref = ref || this.triggerRef
      if (!ref) return
      this._initedTriggerRef = null
      if (this.triggerType === 'hover') {
        ref.removeEventListener('mouseenter', this._hoverEnterEvent)
        ref.removeEventListener('mouseleave', this._hoverLeaveEvent)
        ref.removeEventListener('mousemove', this._hoverOverEvent)

        this.noHiddenAllEls && this.noHiddenAllEls.forEach(item => {
          item.removeEventListener('mouseenter', this._hoverEnterEvent)
        })
      } else if (this.triggerType === 'click') {
        ref.removeEventListener('click', this._clickShowEvent)
      }
      this.deleteShownInstance()
    },
    handleMouseDown(e) {
      if (e.button === 0 && this.show) {
        this.hoverLock = true
      }
    },
    handleMouseUp(e) {
      if (e.button === 0 && this.hoverLock && this.show) {
        this.hoverLock = false
      }
    },
    _click_self_evt(e) {
      const noHiddenAllEls = this.noHiddenClass && document.querySelectorAll('.' + this.noHiddenClass)
      noHiddenAllEls && noHiddenAllEls.forEach(el => {
        if (el.contains(e.target)) {
          return
        }
      })
      if (!this.disabledHidden && this.contentRef && !this.contentRef.contains(e.target)) {
        !this.$el.contains(e.target) && this.hidden()
      }
    },
    _click_evt_func(e) {
      if (window.heyboxPopoverClickEventHandler && window.heyboxPopoverClickEventHandler.length) {
        window.heyboxPopoverClickEventHandler.forEach(inst => {
          inst._click_self_evt(e)
        });
      }
    },
    ...mapMutations(['SET_POPOVER_SHOW']),
  }
}
</script>

<style lang="scss">
.cpt-popover-wrapper {
  position: absolute;
  .popover-arrow {
    border-width: 6px;
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    &[x-placement^=top] {
      bottom: -6px;
      border-bottom-width: 0
    }
    &[x-placement^=bottom] {
      top: -6px;
      border-top-width: 0;
    }
    &[x-placement^=right] {
      left: -6px;
      border-left-width: 0
    }
    &[x-placement^=left] {
      right: -6px;
      border-right-width: 0;
    }
  }
}

</style>